<template>
  <div class="vital-check">
    <div
      class="vital-select-input-group el-input-group el-input-group--append el-input-group--prepend"
    >
      <div class="el-input-group__prepend">Is</div>
      <el-select
        id="vital-select"
        v-close-on-zoom
        :value="state.check.id"
        :placeholder="placeholder"
        class="vital-select"
        :disabled="readonly"
        @input="vitalKey => selectVital(vitalKey)"
      >
        <el-option
          v-for="vital in state.vitals"
          :key="vital.key"
          :label="vital.name.en"
          :value="vital.key"
        />
      </el-select>
    </div>

    <el-select
      v-if="state.check.id"
      id="operator-select"
      v-close-on-zoom
      :value="state.check.operator"
      placeholder="="
      class="operator-select"
      :disabled="readonly"
      @input="operator => updateOperator(operator)"
    >
      <el-option v-for="op in currentOperators" :key="op.value" :label="op.label" :value="op.value" />
    </el-select>

    <state-input
      v-if="state.check.id"
      :state="vitalsByKey[state.check.id]"
      :initial-value="state.check.value"
      :show-label="false"
      :width="width"
      :disabled="readonly"
      :use-default="useDefault"
      class="vital-value-input"
      @input="value => updateVitalValue(value)"
    >
      <template slot="append">?</template>
    </state-input>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy';

import StateInput from '~lib/common/components/StateInput';

export default {
  name: 'vital-check',
  components: {
    StateInput,
  },
  props: [
    'states',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'category',
    'type',
    'placeholder',
    'useDefault',
  ],
  data() {
    return {
      state: {
        vitals: this.states.filter(s => s.category === this.category),
        check: {},
      },
      value: 0,
      operators: [
        { value: 'LESS_THAN', label: '<' },
        { value: 'LESS_THAN_OR_EQUAL', label: '≤' },
        { value: 'EQUAL', label: '=' },
        { value: 'NOT_EQUAL', label: '≠' },
        { value: 'GREATER_THAN_OR_EQUAL', label: '≥' },
        { value: 'GREATER_THAN', label: '>' },
      ],
      width: this.category === 'waveform' ? '200px' : '100px',
    };
  },
  computed: {
    vitalsByKey() {
      return keyBy(this.state.vitals, 'key');
    },
    currentOperators() {
      if (this.vitalsByKey[this.state.check.id].type === 'enum') {
        return this.operators.filter(
          op => op.value === 'EQUAL' || op.value === 'NOT_EQUAL',
        );
      }
      return this.operators;
    },
  },
  mounted() {
    this.state.check = this.getData(this.ikey) || {};
    if (!this.state.check.id) {
      this.state.check.id = this.state.vitals[0].key;
      this.state.check.operator = this.currentOperators[0].value;
    }
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectVital(vitalKey) {
      this.state.check.id = vitalKey;
      this.update();
    },
    updateVitalValue(value) {
      this.state.check.value = value;
      this.update();
    },
    updateOperator(operator) {
      this.state.check.operator = operator;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: this.type,
        ...this.state.check,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
.vital-check {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
}

.vital-select {
  width: 130px;
}

.vital-select-input-group {
  width: auto;
}

.operator-select {
  width: 70px;
}
</style>
